<template>
	<div class="HelpcenterBox_list">
		<div class="HelpcenterBox_list_ul">
			<li>
				<p>
					<span style="font-size: 18px"> 个人中心 </span>
				</p>
				<ul>
					<li :class="{ active: ChildpagesNamelog == '/mine' }">
						<router-link to="/mine"> 我的首页 </router-link>
					</li>
					<li :class="{ active: ChildpagesNamelog == '/mine/ordeRlist' }" style="margin-bottom: 10px">
						<router-link to="/mine/ordeRlist"> 我的订单 </router-link>
					</li>
				</ul>
			</li>
			<li style="margin-top: -5px">
				<p>
					<span style="font-size: 18px"> 财务中心 </span>
				</p>
				<ul>
					<li @click="pathClick">
						<a :class="{ active: ChildpagesNamelog == '/mine/capital-account' }">
							<router-link to="/mine/capital-account">资金账户</router-link>
						</a>
					</li>
					<li @click="pathClick" style="margin-bottom: 10px">
						<a :class="{
							active:
								ChildpagesNamelog == '/mine/invoice' ||
								ChildpagesNamelog == '/invoice'
						}">
							<router-link to="/mine/invoice"> 发票信息</router-link>
						</a>
					</li>
					<!-- <li @click="pathClick">
						<a :class="{active: ChildpagesNamelog == '/mine/akeouTaninvo'}">
							<router-link to="/mine/akeouTaninvo">开票管理</router-link>
						</a>
					</li> -->
				</ul>
			</li>

			<li style="margin-top: -5px">
				<p>
					<span style="font-size: 18px"> 账户设置 </span>
				</p>
				<ul>
					<li @click="pathClick">
						<a :class="{ active: ChildpagesNamelog == '/mine/my-profile' }">
							<router-link to="/mine/my-profile">我的资料 </router-link>
						</a>
					</li>
					<li @click="pathClick">
						<a :class="{ active: ChildpagesNamelog == '/mine/my-adviser' }">
							<router-link to="/mine/my-adviser">我的顾问</router-link>
						</a>
					</li>
					<li @click="pathClick">
						<a :class="{ active: ChildpagesNamelog == '/mine/certification' }">
							<router-link to="/mine/certification">认证企业</router-link>
						</a>
					</li>
					<li @click="pathClick">
						<a :class="{ active: ChildpagesNamelog == '/mine/main-business' }">
							<router-link to="/mine/main-business"> 主营业务</router-link>
						</a>
					</li>

					<li @click="pathClick">
						<a :class="{
							active:
								ChildpagesNamelog == '/mine/shipping-address' ||
								ChildpagesNamelog == '/shipping-address'
						}">
							<router-link to="/mine/shipping-address">收货地址</router-link>
						</a>
					</li>
					<li @click="pathClick">
						<a :class="{ active: ChildpagesNamelog == '/mine/security-center' }">
							<router-link to="/mine/security-center"> 安全中心</router-link>
						</a>
					</li>
					<!-- <li @click="pathClick">
						<a
							:class="{
								active: ChildpagesNamelog == '/mine/thesystem-informs'
							}"
						>
							<router-link to="/mine/thesystem-informs"> 系统通知</router-link>
						</a>
					</li> -->
				</ul>
			</li>
		</div>

		<!-- <div v-if="ChildpagesName == ''">
      <theDefault></theDefault>
    </div> -->

		<div class="HelpcenterBox_list_content">
			<router-view ref="e"></router-view>
		</div>
	</div>
</template>
<script>
import theDefault from "./components/theDefault"
import { GetRealnameAuth } from "@/api/user.js"

export default {
	components: {
		theDefault
	},
	props: {
		cur: {
			type: "String"
		}
	},
	data() {
		return {
			ChildpagesNamelog: "",
			obj: {}
		}
	},
	provide: function () {
		return {
			obj: this.obj
		}
	},
	created() {
		this.pathClick()
	},
	mounted() {
		// GetRealnameAuth().then(res=>{
		//   console.log(res)
		//   window.localStorage.setItem('IsRealNameAuth',res.IsRealNameAuth)
		//   this.obj = res
		// })
	},
	methods: {
		pathClick() {
			if (JSON.stringify(this.$route.query) != "{}") {
				let obj = this.$route.query
				// if(!obj.hasOwnProperty("StatusCode"))this.$route.fullPath = '/mine/ordeRlist'
				if (obj.hasOwnProperty("StatusCode")) this.ChildpagesNamelog = '/mine/ordeRlist'
				else this.ChildpagesNamelog = this.$route.fullPath
			} else {

				this.ChildpagesNamelog = this.$route.fullPath
				console.log(this.$route)
			}

		}
	}
}
</script>

<style lang="scss" scoped>
.active {
	color: #fe641a;
}

.svg-icon[data-v-c8a70580] {
	width: 0.8em;
	height: 1em;
	vertical-align: -0.15em;
	fill: currentColor;
	overflow: hidden;
	font-size: 18px;
}

.HelpcenterBox_list {
	font-size: 18px;
	display: flex;
	width: 1270px;
	margin: 0 auto;
	margin-bottom: 20px;

	.HelpcenterBox_list_ul {
		margin-top: 50px;
		float: left;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		width: 150px;
		height: 550px;
		margin-bottom: 10px;
		// background: #fff;
		margin-right: 40px;
		margin-left: 30px;

		p {
			// margin: 15px 0 2px 15px;
			margin: 0 0 0 -20px;
			font-size: 18px;

			font-weight: 600;
			color: #333333;
		}

		ul {
			display: block;
			list-style-type: disc;
			margin-top: 5px;
			font-size: 12px;
			color: #786f74;

			li:hover {
				color: #ff4f1a;
			}

			li {
				font-size: 18px;
				margin-left: -18px;
				overflow: hidden;
				white-space: nowrap;
				/*限制不换行*/
				text-overflow: ellipsis;
				line-height: 35px;
				// text-align: center;

				p {
					font-size: 14px;
					font-weight: 600;
					color: #333333;

					.icon-spot__e0b197 {
						margin-right: 8px;
					}
				}
			}
		}
	}

	.HelpcenterBox_list_content {
		// margin-left: 10px;
		margin-top: 10px;
		width: 1660px;
		// background-color: #fff;
	}
}
</style>
